import {FC, useEffect, useMemo, useState} from "react";
import {
  InputSearch,
  InputSearchResultBlock,
  InputSearchResultItem,
} from "./styles";
import ImgSearch from "../assets/icons/search-glass.svg";
import IconMolecule from "../assets/icons/molecule_icon.svg";
import {
  IClustersMolecule,
  IMoleculesDataFromServer,
  ITechMolecules2FromServerWithProducts,
} from "../pages/Dashboard/Dashboard.type";
import {ITypeRadar} from "../types";

interface MyInputSearchProps {
  placeholder?: string;
  onOpenMolecule: () => void;
  setIdMoleculeActiv: (arg0: number | string) => void;
  setMoleculeVActive: (arg0: number) => void;
  showListMolecule: 1 | 2;
  moleculesData?: IMoleculesDataFromServer[];
  moleculesData2?: ITechMolecules2FromServerWithProducts[];
  setTypeRadar: (arg0: ITypeRadar) => void;
}

export const MyInputSearch: FC<MyInputSearchProps> = ({
  placeholder,
  onOpenMolecule,
  setIdMoleculeActiv,
  setMoleculeVActive,
  showListMolecule,
  moleculesData,
  moleculesData2,
  setTypeRadar,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredResults, setFilteredResults] = useState<IClustersMolecule[]>(
    []
  );
  const [isInputFocused, setIsInputFocused] = useState(false);

  const selectedMoleculesData =
    showListMolecule === 1 ? moleculesData : moleculesData2;

  const dataMoleculaFromJson = useMemo(
    () => ({
      clusters: selectedMoleculesData
        ? selectedMoleculesData.map((item) => ({
            id: item.id,
            product: "product" in item ? item.product : item.productName,
            data:
              "product" in item
                ? item.clusters.map((cluster) => ({
                    direction_id: 83,
                    cluster_id: cluster.id,
                    technology_id: 2132,
                    strength: cluster.strength,
                    source: "0",
                    technologies: [],
                  }))
                : item.products.map((product) => ({
                    direction_id: 83,
                    cluster_id: product.id,
                    technology_id: 2132,
                    strength: product.strength,
                    source: "0",
                    technologies: [],
                  })),
          }))
        : [],
    }),
    [selectedMoleculesData]
  );

  useEffect(() => {
    if (dataMoleculaFromJson.clusters.length > 0) {
      setFilteredResults(dataMoleculaFromJson.clusters);
    }
  }, [dataMoleculaFromJson]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchTerm(value);
    const results = dataMoleculaFromJson.clusters.filter((item) =>
      item.product.toLowerCase().includes(value.toLowerCase())
    );
    const resultsAll = dataMoleculaFromJson.clusters;
    if (value === "") {
      setFilteredResults(resultsAll);
      return;
    }
    setFilteredResults(results);
  };

  const handleOnClick = (id: number | string) => {
    onOpenMolecule();
    setSearchTerm("");
    setIdMoleculeActiv(id);
    setFilteredResults(dataMoleculaFromJson.clusters);
  };
  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      if (
        event.target &&
        !(event.target as Element).closest(".input-search") &&
        !(event.target as Element).closest(".input-search-result-block")
      ) {
        setIsInputFocused(false);
      }
    };
    document.addEventListener("mousedown", handleMouseDown);
    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, []);
  return (
    <div style={{position: "relative"}}>
      <div style={{padding: "15px 16px 0", position: "relative"}}>
        <InputSearch
          type="search"
          placeholder={placeholder}
          value={searchTerm}
          onChange={handleInputChange}
          onFocus={() => setIsInputFocused(true)}
        />
        {searchTerm.length === 0 && (
          <img
            src={ImgSearch}
            width={16}
            height={16}
            alt="SearchIcon"
            style={{position: "absolute", right: 25, top: 23, zIndex: 1}}
          />
        )}
      </div>

      {isInputFocused && (
        <InputSearchResultBlock className="input-search-result-block">
          <div
            style={{
              padding: "5px 2px 5px 14px",
              fontSize: "14px",
              color: "rgba(255, 255, 255, 0.3)",
            }}
          >
            Популярные запросы
          </div>
          {filteredResults.map((result) => (
            <InputSearchResultItem
              onClick={() => {
                handleOnClick(result.id);
                setIsInputFocused(false);
                setMoleculeVActive(showListMolecule);
                setTypeRadar(
                  showListMolecule === 1 ? "molecula" : "moleculeTwo"
                );
              }}
              key={result.id}
            >
              <img src={IconMolecule} alt="IconMolecule" />
              <p style={{textAlign: "left"}}>{result.product}</p>
            </InputSearchResultItem>
          ))}
        </InputSearchResultBlock>
      )}
    </div>
  );
};
